// One generic "no camera" message hid four different causes. Each needs a
// different action from the user, so name the cause.
export function cameraFoutmelding(err) {
  if (!window.isSecureContext || !navigator.mediaDevices?.getUserMedia) {
    return 'Camera werkt alleen via https. Open havuncore.havun.nl opnieuw.';
  }

  // A Permissions-Policy `camera=()` from the server also surfaces as
  // NotAllowedError, without ever showing the user a prompt.
  const policy = document.permissionsPolicy || document.featurePolicy;
  if (policy?.allowsFeature && !policy.allowsFeature('camera')) {
    return 'Camera geblokkeerd door de site-instellingen. Sluit de app helemaal en open hem opnieuw.';
  }

  switch (err?.name) {
    case 'NotAllowedError':
    case 'SecurityError':
      return 'Geen toestemming voor de camera. Tik op het slotje naast het adres → Rechten → Camera → Toestaan.';
    case 'NotFoundError':
    case 'OverconstrainedError':
      return 'Geen camera gevonden op dit apparaat.';
    case 'NotReadableError':
    case 'AbortError':
      return 'Camera is in gebruik door een andere app. Sluit die app en probeer opnieuw.';
    default:
      return `Camera niet beschikbaar (${err?.name || 'onbekende fout'}).`;
  }
}
